module.exports = __webpack_public_path__ + "img/Fond_outdoor.d9049bc.jpg";